<template>
	<div class="home_more" @click="$emit('click')">了解更多</div>
</template>

<script>
export default {
	name: "index",
}
</script>

<style lang="less" scoped>
.home_more {
	width: 150px;
	height: 60px;
	border: 2px solid @greyLine;
	border-radius: 30px;
	margin: 68px auto 0;
	font-size: 14px;
	color: @gray;
	text-align: center;
	line-height: 58px;
	cursor: pointer;
	background-color: @white;
	position: relative;
	z-index: 1;
	overflow: hidden;
}

.home_more::before {
	content: "";
	background-color: @red;
	border-radius: 30px;
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	transform: scale(0);
	transition: all .5s;
	z-index: -1;
}

.home_more:hover{
	color: @white;
	border-color: transparent;
}

.home_more:hover::before {
	transform: scaleY(1);
}
</style>
